export const shortStatsContainerSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const itemContainer = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};
